import React from 'react'

// Rounded input + Send button; shows a Stop button while loading.
export default function ChatInputBar({
  value, onChange, onSend, onStop, loading,
  placeholder = 'Type a message...', inputRef,
}) {
  return (
    <div style={{ background: '#fff', borderTop: '1px solid #CED1D6', padding: '10px 12px', display: 'flex', gap: 8, flexShrink: 0 }}>
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSend() } }}
        placeholder={placeholder}
        disabled={loading}
        aria-label="Message the assistant"
        style={{
          all: 'unset', boxSizing: 'border-box', flex: 1, border: '1px solid #5B68C3', borderRadius: 24,
          padding: '9.5px 14.5px', fontSize: 13, fontFamily: 'Inter, sans-serif',
          background: loading ? '#f8fafc' : '#fff', color: '#3C4654',
        }}
      />
      {loading ? (
        <button
          onClick={onStop}
          aria-label="Stop generating"
          style={{ all: 'unset', boxSizing: 'border-box', cursor: 'pointer', background: '#5B68C3', color: '#fff', borderRadius: 24, padding: '10.25px 16px', fontWeight: 700, fontSize: 13, flexShrink: 0, fontFamily: 'Inter, sans-serif', lineHeight: '15px', display: 'flex', alignItems: 'center', gap: 5 }}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#4A57B2' }}
          onMouseLeave={(e) => { e.currentTarget.style.background = '#5B68C3' }}
        >
          Stop
          <svg width="11" height="11" viewBox="0 0 11 11" aria-hidden="true"><rect x="0.5" y="0.5" width="10" height="10" rx="2" fill="white" /></svg>
        </button>
      ) : (
        <button
          onClick={onSend}
          disabled={!value.trim()}
          aria-label="Send"
          style={{ all: 'unset', boxSizing: 'border-box', cursor: !value.trim() ? 'default' : 'pointer', background: !value.trim() ? '#a3a8ad' : '#5B68C3', color: '#fff', borderRadius: 24, padding: '10.25px 16px', fontWeight: 700, fontSize: 13, flexShrink: 0, fontFamily: 'Inter, sans-serif', lineHeight: '15px', display: 'flex', alignItems: 'center', gap: 5 }}
          onMouseEnter={(e) => { if (value.trim()) e.currentTarget.style.background = '#4A57B2' }}
          onMouseLeave={(e) => { if (value.trim()) e.currentTarget.style.background = '#5B68C3' }}
        >
          Send
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M11.9166 1.0835L5.95825 7.04183M11.9166 1.0835L8.12492 11.9168L5.95825 7.04183M11.9166 1.0835L1.08325 4.87516L5.95825 7.04183" stroke="white" strokeWidth="1.35417" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  )
}
